// src/routes/AppRoutes.js
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import receptionRoutes from "./ReceptionRoutes/ReceptionRoutes";
import pharmacyRoutes from "./PharmacyRoutes/PharmacyRoutes";
import doctorRoutes from "./DoctorRoutes/DoctorRoutes";
import nurseRoutes from "./NurseRoutes/NurseRoutes";
import xrayRoutes from "./XrayRoutes/XrayRoutes";
import ultrasoundRoutes from "./UltraSoundRoutes/UltraSoundRoutes";
import laboratoryRoutes from "./LaboratoryRoutes/LaboratoryRoutes";
import echocardiographyRoutes from "./EchocardiographyRoutes/EchocardiographyRoutes";
import patientProfileRoutes from "./PatientProfile/PatientProfile";
import financeRoutes from "./FinanceRoutes/FinanceRoutes";
import humanResourceRoutes from "./HRRoutes/HRRoutes";
import SignInView from "../pages/Authentication/SignIn/SignIn";
import CallCenterRoutes from "./CallCenterRoutes/CallCenterRoutes";
import dentalRoutes from "./DentalRoutes/DentalRoutes";
import BeautyRoutes from "./BeautyRoutes/BeautyRoutes";
import operationsRoutes from "./OperationsRoutes/OperationsRoutes";
import HtPatientRoutes from "./HtPatientRoutes/HtPatientRoutes";
import auditRoutes from "./AuditRoutes/AuditRoutes";

export const createAppRouter = (permissions) => {
  // Conditionally add routes based on permissions
  const childrenRoutes = [
    permissions.reception && receptionRoutes,
    permissions.pharmacy && pharmacyRoutes,
    permissions.doctor && doctorRoutes,
    permissions.nurse && nurseRoutes,
    permissions.x_ray && xrayRoutes,
    permissions.ultrasounds && ultrasoundRoutes,
    permissions.laboratory && laboratoryRoutes,
    permissions.echo && echocardiographyRoutes,
    permissions.finance && financeRoutes,
    permissions.hr && humanResourceRoutes,
    permissions.dental && dentalRoutes,
    permissions?.call_center && CallCenterRoutes,
    permissions?.beauty && BeautyRoutes,
    permissions?.htPatient && HtPatientRoutes,
    permissions.operations && operationsRoutes,
    permissions?.is_staff && auditRoutes,
  ].filter(Boolean);

  return createBrowserRouter([
    {
      path: "/",
      element: <App />,
      children: [...childrenRoutes, patientProfileRoutes],
    },
    { path: "user/sign-in/", element: <SignInView /> },
    { path: "*", element: <Navigate to={"/"} /> },
  ]);
};
